import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAtom, useAtomValue, WritableAtom } from 'jotai';
import { errorAtom } from 'atoms/error';
import { authTokenAtom } from 'atoms/authAtoms';
import { useLots } from 'utils/hooks/useLToolTree';
import { useAutoSelectSingle } from 'utils/hooks/useAutoSelectSingle';
import { Config } from 'atoms/Ltool/newConfigAtoms';

type Props = {
    atom: WritableAtom<string, [newProjectId: string], void>;
    config: Config;
};

export const LotSelect: React.FC<Props> = ({ atom, config }) => {
    const authToken = useAtomValue(authTokenAtom);
    const [lotId, setLotId] = useAtom(atom);
    const [error] = useAtom(errorAtom);
    const { items: lots, loading } = useLots(authToken, config);
    // 選択肢が1件のみの段は自動選択し、一意に定まる限り下位へ連鎖させる
    useAutoSelectSingle(lots, loading, lotId, setLotId);

    return (
        <Box sx={{ flex: '1 1 calc(50% - 16px)' }}>
            <FormControl fullWidth disabled={!config.destination_id || loading} error={Boolean(error)}>
                <InputLabel id="lot-select-label">Lot</InputLabel>
                <Select
                    labelId="lot-select-label"
                    value={lotId}
                    label="Lot"
                    onChange={(e) => setLotId(e.target.value as string)}
                >
                    <MenuItem value="">
                        <em>None</em>
                    </MenuItem>
                    {lots.map((lot) => (
                        <MenuItem key={lot} value={lot}>
                            {lot}
                        </MenuItem>
                    ))}
                </Select>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{ position: 'absolute', top: '50%', right: 16, mt: '-12px' }}
                    />
                )}
            </FormControl>
        </Box>
    );
};
